import { createSlice } from '@reduxjs/toolkit';

const SELECTED_DEVICE_KEY = 'qa_selected_device';
const SELECTED_APP_BUILD_KEY = 'qa_selected_app_build';

function loadSelectedDevice() {
  try {
    const raw = localStorage.getItem(SELECTED_DEVICE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function loadSelectedAppBuild() {
  try {
    const build = localStorage.getItem(SELECTED_APP_BUILD_KEY);
    return build || '';
  } catch {
    return '';
  }
}
const initialState = {
  appiumUrl: localStorage.getItem('qa_appium_url') || '',
  adbRunnerUrl: localStorage.getItem('qa_adb_runner_url') || '',
  selectedDevice: loadSelectedDevice(),
  selectedAppBuild: loadSelectedAppBuild(),
};

const platformSlice = createSlice({
  name: 'platform',
  initialState,
  reducers: {
    setAppiumUrl(state, action) {
      state.appiumUrl = action.payload;
      if (action.payload) {
        localStorage.setItem('qa_appium_url', action.payload);
      } else {
        localStorage.removeItem('qa_appium_url');
      }
    },
    setAdbRunnerUrl(state, action) {
      state.adbRunnerUrl = action.payload;
      if (action.payload) {
        localStorage.setItem('qa_adb_runner_url', action.payload);
      } else {
        localStorage.removeItem('qa_adb_runner_url');
      }
    },
    setSelectedDevice(state, action) {
      state.selectedDevice = action.payload;

      if (action.payload) {
        localStorage.setItem(SELECTED_DEVICE_KEY, JSON.stringify(action.payload));
      } else {
        localStorage.removeItem(SELECTED_DEVICE_KEY);
      }
    },
    setSelectedAppBuild(state, action) {
      state.selectedAppBuild = action.payload;
      if (action.payload) {
        localStorage.setItem(SELECTED_APP_BUILD_KEY, action.payload);
      } else {
        localStorage.removeItem(SELECTED_APP_BUILD_KEY);
      }
    },
  },
});

export const { setAppiumUrl, setAdbRunnerUrl, setSelectedDevice, setSelectedAppBuild } =
  platformSlice.actions;

export const selectAppiumUrl = (state) => state.platform.appiumUrl;
export const selectAdbRunnerUrl = (state) => state.platform.adbRunnerUrl;
export const selectSelectedDevice = (state) => state.platform.selectedDevice;
export const selectSelectedAppBuild = (state) => state.platform.selectedAppBuild;

export default platformSlice.reducer;
